import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';

import { LANGUAGE_KEY, defaultLocale, supportedLanguages } from '../../util/languages';
import { OutsideClickHandler } from '../../components';
import { getCountryFlagById } from '../../util/getCountryFlag';

import css from './MultiLanguageSelect.module.css';

const MultiLanguageSelectComponent = props => {
  const { onUpdateProfile, currentUser } = props;

  const [isOpen, setIsOpen] = useState(false);

  const currentLocale =
    (typeof window !== 'undefined' && window.localStorage.getItem(LANGUAGE_KEY)) || defaultLocale;

  //set language to saved value if any
  useEffect(() => {
    const savedLanguageMaybe =
      currentUser?.attributes?.profile?.publicData?.language ||
      window.localStorage.getItem(LANGUAGE_KEY) ||
      currentLocale;

    if (currentLocale !== savedLanguageMaybe) {
      window.localStorage.setItem(
        LANGUAGE_KEY,
        currentUser?.attributes?.profile?.publicData?.language
      );
    }
  }, []);

  const handleLanguageSwitch = async lang => {
    if (currentUser?.id?.uuid) {
      await onUpdateProfile({
        publicData: {
          language: lang,
        },
      });
    }

    if (typeof window !== 'undefined') {
      window.localStorage.setItem(LANGUAGE_KEY, lang);
    }

    if (typeof document !== 'undefined') {
      document.location.reload(true);
    }
  };

  const selectedLanguage = supportedLanguages.find(l => l.key === currentLocale);

  return (
    <OutsideClickHandler className={css.langSwitchWrapper} onOutsideClick={() => setIsOpen(false)}>
      <div
        role="button"
        className={css.toggleButton}
        onClick={() => setIsOpen(prevState => !prevState)}
        tabIndex={0}
        onKeyDown={() => setIsOpen(prevState => !prevState)}
      >
        <span className={css.flag}>{getCountryFlagById(selectedLanguage?.flag)}</span>
        <span className={css.label}>{selectedLanguage?.label}</span>
      </div>

      {isOpen && (
        <ul className={css.langSwitchContent}>
          {supportedLanguages.map(l => (
            <li
              key={l.key}
              className={classNames(css.labelWrapper, {
                [css.labelWrapperActive]: currentLocale === l.key,
              })}
              onClick={() => handleLanguageSwitch(l.key)}
              key={l.key}
            >
              <span className={css.flag}>{getCountryFlagById(l.flag)}</span>
              <span className={css.label}>{l.label}</span>
            </li>
          ))}
        </ul>
      )}
    </OutsideClickHandler>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const MultiLanguageSelect = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(MultiLanguageSelectComponent);

export default MultiLanguageSelect;
